import { useState } from 'react';

// The square app icon from the supplied artwork (public/brand-artwork.png,
// 258px square at 988,414), cut out at 180px with sips. The mark is at most
// 52px, so this covers three times its size; the browser no longer downloads
// the 1.1 MB artwork to show it (FE-04).
export const BRAND_ICON_URL = '/brand-icon-180.png';

function safeLogoUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const url = new URL(value.trim(), globalThis.location?.origin || 'https://preview.invalid');
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
  } catch {
    return '';
  }
}

export default function BrandMark({ branding = {}, size = 52, className = '' }) {
  const [failedLogo, setFailedLogo] = useState('');
  const [failedArtwork, setFailedArtwork] = useState(false);
  const customLogo = safeLogoUrl(branding?.logoUrl);
  const initials = String(branding?.companyName || 'Risk Intelligence').trim().split(/\s+/).slice(0,2).map(word => Array.from(word)[0] || '').join('').toUpperCase();

  return <span
    aria-hidden="true"
    className={`brand-mark ${className}`.trim()}
    style={{
      display: 'inline-block',
      position: 'relative',
      overflow: 'hidden',
      flex: 'none',
      width: size,
      height: size,
      borderRadius: Math.round(size * 0.23),
      background: 'var(--surface3)',
    }}
  >
    {customLogo && failedLogo !== customLogo
      ? <img src={customLogo} alt="" onError={() => setFailedLogo(customLogo)}
          style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}/>
      : failedArtwork ? <span data-brand-fallback style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%',height:'100%',color:'var(--text)',fontWeight:700,fontSize:Math.max(12,Math.round(size*.38))}}>{initials || 'RI'}</span>
      : <img src={BRAND_ICON_URL} alt="" draggable="false" onError={() => setFailedArtwork(true)}
          style={{ display: 'block', width: '100%', height: '100%' }}/>
    }
  </span>;
}
